import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl, getAuthToken } from '../../../services/api';

const API_BASE = () => `${getApiBaseUrl()}/api/admin/resources`;

const FiltersSearchTab = () => {
  const { t } = useTranslation('resourcesManagement');
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState('');
  const [level, setLevel] = useState('');
  const [year, setYear] = useState('');
  const [subject, setSubject] = useState('');
  const [fileType, setFileType] = useState('');

  const runSearch = () => {
    setLoading(true);
    const token = getAuthToken();
    const headers = { Accept: 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    const params = new URLSearchParams();
    if (q) params.set('q', q);
    if (level) params.set('level', level);
    if (year) params.set('year', year);
    if (subject) params.set('subject', subject);
    if (fileType) params.set('fileType', fileType);
    fetch(`${API_BASE()}/search?${params}`, { headers })
      .then((r) => r.json())
      .then((data) => data.success && setExams(data.exams || []))
      .finally(() => setLoading(false));
  };

  return (
    <div className="tab-content">
      <div className="resources-filters-row">
        <input type="text" placeholder={t('filtersSearch.searchPlaceholder')} value={q} onChange={(e) => setQ(e.target.value)} />
        <select value={level} onChange={(e) => setLevel(e.target.value)}>
          <option value="">{t('filtersSearch.filterByLevel')}</option>
          <option value="primary">Primary</option>
          <option value="middle">Middle</option>
          <option value="high">High</option>
        </select>
        <input type="text" placeholder={t('filtersSearch.filterByYear')} value={year} onChange={(e) => setYear(e.target.value)} />
        <input type="text" placeholder={t('filtersSearch.filterBySubject')} value={subject} onChange={(e) => setSubject(e.target.value)} />
        <select value={fileType} onChange={(e) => setFileType(e.target.value)}>
          <option value="">{t('filtersSearch.filterByFileType')}</option>
          <option value="pdf">PDF</option>
          <option value="word">Word</option>
        </select>
        <button type="button" className="action-btn" onClick={runSearch} disabled={loading}>Search</button>
      </div>
      {loading && <div className="loading-message">Searching...</div>}
      <div className="resources-table-wrap">
        <table className="resources-table">
          <thead>
            <tr>
              <th>{t('examManagement.title')}</th>
              <th>{t('examManagement.level')}</th>
              <th>{t('examManagement.year')}</th>
              <th>{t('examManagement.subject')}</th>
              <th>{t('examManagement.downloads')}</th>
            </tr>
          </thead>
          <tbody>
            {exams.map((row) => (
              <tr key={row.id}>
                <td>{row.title}</td>
                <td>{row.level}</td>
                <td>{row.year}</td>
                <td>{row.subject}</td>
                <td>{row.download_count ?? 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!loading && !exams.length && <p className="resources-table-empty">Use filters and click Search.</p>}
      </div>
    </div>
  );
};

export default FiltersSearchTab;
